import { useMutation } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';

export const usePublishDraftJobPost = () => {
  return useMutation({
    mutationFn: (jobPostingId: string) => {
      return PermanentJobsService.publishDraftJobPost(jobPostingId);
    },
  });
};
